<template>
  <div class="faq-component" :id="faq.order">
    <div class="question-container">
      <h5>{{ $language.current | translateToCurrentLang(faq.questionEs, faq.questionEn) }}</h5>
    </div>
    <div class="paragraph-container">
      <span
        v-html="
          content
        "
      ></span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getVariableReplacement } from '@/services/organizationCustomVariables'
import {currencyFormat} from '@/services/utils'
import '@/services/utils'
export default {
  name: 'FAQComponent',
  props: {
    faq: {
      type: Object,
      default: null,
    },
  },
  computed: { 
    ...mapState(['organizationDetails']),

    content(){
      const lang = this.$language.current
      const additionalCustoms = {
        'organization.name': this.organizationDetails.name,
        'organization.grantLimit' : currencyFormat(this.organizationDetails.grantLimit, lang, true),
        'organization.supportEmail': this.organizationDetails.supportEmail,
        'organization.rollingGrantDuration': this.organizationDetails.rollingGrantDuration,
      }
      switch (lang){
        case 'en_US':
          return this.faq.answer.answerHtmlEn.formatUnicorn({...this.organizationDetails.customVariablesEn, ...additionalCustoms})
        case 'es_ES':
          return this.faq.answer.answerHtmlEs.formatUnicorn({...this.organizationDetails.customVariablesEs, ...additionalCustoms})
        default:
          console.log('Language has been set to an unknown language.')
      }

      // return getVariableReplacement(
      //       this.faq.answer.answerHtmlEn,
      //       this.faq.answer.answerHtmlEs,
      //       this.organizationDetails,
      //       this.$language.current,
      //     )
    },
  
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixins/buttons';
@import '@/styles/mixins/containers';

.faq-component {
  width: 100%;
}

.question-container {
  width: 100%;
  padding: 1rem;
  background: var(--light-brand-color);
  box-shadow: 0 4px 8px 0 $mid-gray;
  border-radius: 1rem;
  margin-bottom: 1.2rem;
  margin-top: 1.2rem;

  & > h5 {
    margin: 0;
  }
}

.paragraph-container {
  width: 100%;
  margin: 0 auto;
}
</style>
